var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "keyboard-error-window"
  }, [_c('div', {
    staticClass: "keyboard-error-window-text"
  }, [_vm._m(0), _c('button', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.relogin($event);
      }
    }
  }, [_vm._v("Reload")])]), _c('a', {
    staticClass: "modal-close-button progress keyboard-error",
    attrs: {
      "aria-label": "Close modal",
      "role": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonClose)
    },
    on: {
      "click": _vm.closeModal
    }
  })]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h3', [_vm._v("\n      Oops, something went wrong! Please get your teacher!\n      "), _c('br'), _c('br'), _vm._v("\n      We have detected a key input error which can be caused by an incompatible keyboard. Please\n      make sure that your keyboarding input on the device is set to English (US).\n      "), _c('br'), _c('br'), _vm._v("\n      You can do this by going to your device settings under Settings/Device/Keyboard/Change Input\n      Settings.\n      "), _c('br'), _c('br'), _vm._v("\n      If the issue persists, try reloading the activity.\n    ")]);
}]

export { render, staticRenderFns }